import { render, staticRenderFns } from "./Websites.vue?vue&type=template&id=1c127956&scoped=true"
import script from "./Websites.vue?vue&type=script&lang=js"
export * from "./Websites.vue?vue&type=script&lang=js"
import style0 from "./Websites.vue?vue&type=style&index=0&id=1c127956&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c127956",
  null
  
)

export default component.exports